import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import SetupGuide from "@/components/SetupGuide.vue";
import Home from "@/components/Home.vue";
import store from '@/store'
import Config from "@/components/Config.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        name: 'setup',
        path: '/setup',
        component: SetupGuide,
    },
    {
        name: 'home',
        path: '',
        component: Home,
        /**
         * Antes de entrar al Home comprueba si la aplicación se encuentra configurada.
         * Si no lo estuviera el usuario sería redireccionado al Setup
         *
         * @param to
         * @param from
         * @param next
         */
        beforeEnter(to, from, next) {
            if (!store.getters.isConfigured) {
                return next({name: 'setup'})
            }

            next()
        }
    },
    {
        name: 'config',
        path: '/ajustes',
        component: Config,
    }
]

const router = new VueRouter({
    routes
})

export default router
